import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { ReactNode } from "react";

type ManualReviewSectionProps = {
  label: string;
  children: ReactNode;
  error?: boolean;
  errorMessage: string;
};

const ManualReviewSection = ({
  label,
  children,
  error,
  errorMessage,
}: ManualReviewSectionProps) => {
  return (
    <div
      className={classNames("section__container", { section__error: error })}
    >
      <span className="section__header">
        {error ? <FontAwesomeIcon icon="exclamation-circle" /> : null}
        {label}
      </span>
      {error ? errorMessage : children}
    </div>
  );
};

export default ManualReviewSection;
